import React from "react";
import AddCouponContainer from "../../containers/Coupons/AddCoupon/index";

const AddCouponPage = () => {
  return (
    <>
      <AddCouponContainer />
    </>
  );
};

export default AddCouponPage;
